// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"989d56a3","669":"12ac853b","787":"e36ff01b"}[chunkId] + ".chunk.js";
};